import { get, post, del, put } from '@/libs/api.request'

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    getCustomers ({ commit }, data) {
      return get('customers', data)
    },
    getCustomer ({ commit }, id) {
      return get(`customers/${id}`)
    },
    createCustomer ({ commit }, data) {
      return post('customers/create', data)
    },
    deleteCustomer ({ commit }, id) {
      return del(`customers/${id}`)
    },
    updateCustomer ({ commit }, data) {
      return put(`customers/${data.id}`, data)
    }
  }
}
